import stateOptions from "web_modules/forms/data/stateOptions";
import APIClient from "../../APIClient";

import { SEARCH_DATA_LOADED, SEARCH_TERM_UPDATED } from "./types";

const stateMap = stateOptions.reduce(
  (acc, details) => ({ ...acc, [details.label]: details.state }),
  {},
);
export const appSearchTransformer = app => ({
  ...app,
  loanid: [app.lead_number, app.external_id],
  name: [
    app.borrower1_first_name,
    app.borrower1_last_name,
    app.borrower2_first_name,
    app.borrower2_last_name,
    app.borrower3_first_name,
    app.borrower3_last_name,
    app.borrower4_first_name,
    app.borrower4_last_name,
  ],
  email: [app.borrower1_email, app.borrower2_email, app.borrower3_email, app.borrower4_email],
  address: [
    app.purchased_property_address_line1,
    app.purchased_property_address_line2,
    app.purchased_property_city,
    app.purchased_property_state,
    app.purchased_property_postal_code,
    (app.purchased_property_address_line1 || "").replace(/[^0-9a-z]/gi, " "),
    (app.purchased_property_address_line2 || "").replace(/[^0-9a-z]/gi, " "),
    (app.purchased_property_city || "").replace(/[^0-9a-z]/gi, " "),
    stateMap[app.purchased_property_state],
    ...(app.purchased_property_postal_code || "").replace(/[^0-9a-z]/gi, " ").split(" "),
  ],
});

const searchDataLoaded = payload => ({
  payload,
  type: SEARCH_DATA_LOADED,
});

const searchTermUpdated = payload => ({
  payload,
  type: SEARCH_TERM_UPDATED,
});

export const loadSearchData = () => dispatch => {
  APIClient.get(`/loan_apps`).then(
    (resp: any) => {
      dispatch(searchDataLoaded(resp.applications.map(appSearchTransformer)));
    },
    () => {
      dispatch(searchDataLoaded([]));
    },
  );
};

export const loadSettlementAgentSearchData = () => dispatch => {
  APIClient.get(`/sa/loan_apps`).then(
    (resp: any) => {
      dispatch(searchDataLoaded(resp.applications.map(appSearchTransformer)));
    },
    () => {
      dispatch(searchDataLoaded([]));
    },
  );
};

export const updateSearchTerm = (searchTerm: string) => dispatch => {
  dispatch(searchTermUpdated(searchTerm));
};
